export enum QuestionType {
  SINGLE_CHOICE = 'single_choice',
  MULTIPLE_CHOICE = 'multiple_choice',
  INT_ANS = 'integer_answer',
  RANGE_ANS = 'range_answer',
  MATRIX_MATCH = 'matrix_match',
  LONG_ANSWER = 'long_answer',
}
